<template>
  <div class="row">
    <div class="col-lg-12">
      <el-alert
        :closable="false"
        class="mb-3 col-12"
        title="💡 Info"
        type="success"
      >
        <p>
          <b>Call</b> setting is where you can set time for your workspace call configuration
          when using the call. The configuration that you enabled and set below will
          determine when you workspace is actively having the call.
        </p>
        <br />
        <p>
          - You can enable the work hour configuration to define the operational hours.
        </p>
        <p>
          - You can set the IVR Setup which this tools are supporting the call.
        </p>
        <p>
          - You can set the number for forwarding the call according request the client.
        </p>
      </el-alert>
      <el-card shadow="never">
        <el-form label-width="180px" label-position="left">
            <el-form-item>
            <span class="font-weight-bold" slot="label">Call Operation Time</span>
            <el-switch @change="handleOperationTime" v-model="form_channels.work_hour.status" active-color="#128c7f" />
            </el-form-item>
            <span v-if="form_channels.work_hour.status">
              <el-form class="d-flex" :model="form_channels.work_hour">
                <el-form-item class="mr-3" label="Start Day :">
                  <el-select v-model="form_channels.work_hour.config[0].start_day" placeholder="Select Start Day">
                    <el-option
                      v-for="day in days"
                      :key="day"
                      :label="day"
                      :value="day"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="End Day :">
                  <el-select v-model="form_channels.work_hour.config[0].end_day" placeholder="Select End Day">
                    <el-option
                      v-for="day in days"
                      :key="day"
                      :label="day"
                      :value="day"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item class="ml-3" label="Range Time :">
                    <el-time-picker
                    size="small"
                    is-range
                    format="HH:mm"
                    v-model="form_channels.work_hour.config[0].model"
                    @change="handleRangeLocalOpsTime"
                    range-separator="To"
                    start-placeholder="Range time"
                    end-placeholder="End time"
                    >
                </el-time-picker>
                </el-form-item>
              </el-form>
            </span>
        </el-form>
      </el-card>
      <el-card v-if="Object.keys(form_channels.ivr).length > 0" class="mt-3" shadow="never">
        <el-form>
            <el-form-item>
              <div>
                  <span class="font-weight-bold mr-3" slot="label">IVR Setup</span>
                  <br />
                  <span v-if="isIVRNotExist()" class="badge badge-danger p-2 w-100 mb-3">There is no existing IVR</span>
                  <div v-else>
                    <div>
                      <div v-for="[key, value] in Object.entries(form_channels.ivr)" :key="key" class="d-flex mt-2">
                        <span class="font-weight-bold mr-3 w-20" slot="label">{{ label_ivr[key] }} :</span>
                        <b-form-file
                        class="w-20"
                        accept=".mp3, .mp4"
                        placeholder="Choose a file or drop it here."
                        drop-placeholder="Drop file here."
                        v-model="form_channels.ivr[key].file"
                      ></b-form-file>
                      <el-button type="primary" v-if="typeof value.source_file === 'string' && value.source_file !== ''" style="font-size: 12px;" @click="previewUrlIvr(key)" class="ml-3 h-20 btn btn-primary small text-sm p-2">Open Link</el-button>
                      </div>
                    </div>
                  </div>
                <el-progress v-if="loading.upload_file" :percentage="upload_progress" :status="upload_status"></el-progress>
              </div>
            </el-form-item>
        </el-form>
      </el-card>
      <el-card v-if="form_channels.forward_number !== ''" class="mt-3" shadow="never">
        <el-form>
            <el-form-item>
                <div>
                    <p class="font-weight-bold mr-3" slot="label">Forward Call To</p>
                    <el-input
                    class="w-20 mt-2"
                    type="number"
                    readonly
                    placeholder="Fill phone number for forward call" v-model="form_channels.forward_number" />
                </div>
            </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { upperFirst, isEmpty } from 'lodash';
import channels from '../../../api/channels';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  name: 'Call',
  props: {
    workspace_id: {
      type: String,
    },
  },
  data() {
    return {
      loading: {
        setting: true,
        update_work_hour: false,
        update_forward_number: false,
        update_ivr: false,
      },
      loaderStack: 0,
      loader: null,
      form_channels: {
        id: null,
        forward_number: '',
        ivr: {},
        work_hour: {
          status: false,
          config: [
            {
              // status: true,
              start_day: 'Sunday',
              end_day: 'Monday',
              start: '00:00',
              until: '00:00',
              model: [moment('00:00', 'hh:mm'), moment('00:00', 'hh:mm')],
            },
          ],
        },
      },
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      label_ivr: {
        greeting: 'IVR Greeting',
        waiting_queue: 'IVR Waiting Queue',
        busy: 'IVR Busy',
        forwarding: 'IVR Forwarding',
      },
      company_id: this.$store.state.company.activeCompany.id,
    };
  },
  mounted() {
    // const temp = [];
    /* eslint-disable no-plusplus */
    // for (let i = 0; i < 7; i++) {
    //   temp.push({
    //     day: i,
    //     day_name: moment().weekday(i).format('dddd'),
    //     from: '00:00',
    //     until: '00:00',
    //     status: false,
    //   });
    // }
    // this.form_channels.work_hour.config = temp;
  },
  methods: {
    isIVRNotExist() {
      if (!isEmpty(this.form_channels.ivr)) {
        const {
          greeting,
          waiting_queue,
          busy,
          forwarding,
        } = this.form_channels.ivr;
        if (typeof waiting_queue === 'string' && typeof busy === 'string' && typeof greeting === 'string' && typeof forwarding === 'string') {
          return (
            greeting.source_file === ''
            && waiting_queue.source_file === ''
            && busy.source_file === ''
            && forwarding.source_file === ''
          );
        }
        if (typeof greeting.source_file === 'string') {
          return greeting.source_file === '';
        }
      }
      return false;
    },
    upperCaseFirst(string) {
      return upperFirst(string);
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async loadData() {
      this.$parent.loading.setting = true;
      const response = await channels.getChannelPhoneCall(this.workspace_id, this.company_id);
      this.hideLoader();
      this.$parent.loading.setting = false;
      await popupErrorMessages(response);
      const channel_phone_call = response.data;
      if (channel_phone_call?.details?.work_hour?.config[0]) {
        const [front_start_time, back_start_time] = channel_phone_call.details.work_hour.config[0].start_time.split(':');
        const [front_end_time, back_end_time] = channel_phone_call.details.work_hour.config[0].end_time.split(':');
        channel_phone_call.details.work_hour.config[0] = {
          ...channel_phone_call?.details?.work_hour?.config[0],
          model: [
            moment().hour(parseInt(front_start_time, 0)).minute(parseInt(back_start_time, 0)).format(),
            moment().hour(parseInt(front_end_time, 0)).minute(parseInt(back_end_time, 0)).format(),
          ],
        };
      }
      this.form_channels = {
        id: channel_phone_call?._id ?? null,
        forward_number: channel_phone_call?.details?.forward_number ?? '',
        ivr: channel_phone_call?.details?.ivr ?? {},
        work_hour: {
          ...this.form_channels.work_hour,
          status: channel_phone_call?.details?.work_hour?.status ?? false,
          config: channel_phone_call?.details?.work_hour?.config ?? this.form_channels.work_hour.config,
        },
      };
    },
    handleRangeLocalOpsTime(time) {
      const [start, end] = time;
      this.form_channels.work_hour.config[0].model = [moment(start).format('YYYY-MM-DDTHH:mm:ssZ'), moment(end).format('YYYY-MM-DDTHH:mm:ssZ')];
    },
    async previewUrlIvr(type) {
      const { data } = await channels.previewUrlIvr(this.form_channels.id, this.workspace_id, type, this.company_id);
      window.open(data.url);
    },
    handleOperationTime() {
      if (this.form_channels.work_hour.config.length === 0) {
        this.$message({
          type: 'error',
          message: this.$t('settings.failed.phone_invalid'),
        });
      }
    },
  },
};
</script>
